<template>
    <div class="accordion" id="accordionCredito">
        <div class="accordion-item opcionDetalle">
            <h2 class="accordion-header" id="headingCredito">
                <button class="accordion-button collapsed btn btn-primary rounded-pill" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCredito" aria-expanded="false" aria-controls="collapseCredito">
                    Crédito
                </button>
            </h2>
            <div id="collapseCredito" class="accordion-collapse collapse" aria-labelledby="headingCredito" data-bs-parent="#accordionCredito">
                <div class="accordion-body">
                    <div class="card card-body text-start mb-3 cabeceraDetalle">
                        <h5 class="card-title">Mensualidad vigente: {{ $filters.MoneyFilter(operacion.mensualidadVigente)}}</h5>
                    </div>
                    <div v-for="cliente in operacion.clientes" :key="cliente.clienteId">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <div class="card card-body text-start mb-3 cuerpoDetalle">
                                    <h5 class="card-title">
                                        Cliente: {{ $filters.CapitalizeFilter(cliente.nombre) }}
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <div class="card card-body text-start mb-3 cuerpoDetalle">
                                    <h5 class="card-title">
                                        Comentarios Analista:
                                        <ul>
                                            <li v-for="comentario in $filters.StringFilter(operacion.opinionAnalista).split('\r\n')" :key="comentario">
                                                {{comentario}}
                                            </li>
                                        </ul>
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-6">
                                <div class="card card-body text-start mb-3 cuerpoDetalleI">
                                    <h5 class="card-title">
                                        Datos buró de crédito
                                    </h5>
                                    <hr />
                                    <div class="texto mb-3">
                                        Pago mensual:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(
                                                    cliente.consultaBuroCredito.pagoMensual
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="texto mb-3">
                                        Deuda actual:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(
                                                    cliente.consultaBuroCredito.deudaActual
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="texto mb-3">
                                        Saldo vencido:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(
                                                    cliente.consultaBuroCredito.saldoVencido
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <div class="card card-body text-start mb-3 cuerpoDetalleD">
                                    <h5 class="card-title">
                                        Comprobación y capacidades
                                    </h5>
                                    <hr />
                                    <div class="texto mb-3">
                                        Ingresos:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(calcularIngresosTotales(cliente.ingresos))
                                            }}
                                            <div class="col-md-4">
                                                <button
                                                    type="button"
                                                    class="btn btn-primary rounded-pill mt-3"
                                                    data-bs-toggle="modal"
                                                    :data-bs-target="`#modalPersona${cliente.clienteId}`"
                                                >
                                                    Detalle
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="texto mb-3">
                                        Egresos:
                                        <div class="float-end me-3">
                                            {{ $filters.MoneyFilter(cliente.egresos) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <modal-detalle-ingresos :persona="cliente"></modal-detalle-ingresos>
                        <!--Inicio CCD-0003 Separación de gráfico de mops en cuentas activas y cerradas-->
                        <div class="row" v-if="cliente.cuentasBuroActivas.cuentas.length > 0 || cliente.cuentasBuroCerradas.cuentas.length > 0">
                            <div class="col">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                <li v-if="cliente.cuentasBuroActivas.cuentas.length > 0" class="nav-item" role="presentation">
                                    <button class="nav-link active" :id="`activa${cliente.clienteId}-tab`" data-bs-toggle="tab" :data-bs-target="`#activa${cliente.clienteId}`" type="button" role="tab" :aria-controls="`activa${cliente.clienteId}`" aria-selected="true">Cuentas activas</button>
                                </li>
                                <li v-if="cliente.cuentasBuroCerradas.cuentas.length > 0" class="nav-item" role="presentation">
                                    <button class="nav-link" :id="`cerrada${cliente.clienteId}-tab`" data-bs-toggle="tab" :data-bs-target="`#cerrada${cliente.clienteId}`" type="button" role="tab" :aria-controls="`cerrada${cliente.clienteId}`" aria-selected="false">Cuentas cerradas</button>
                                </li>
                                </ul>
                                <div class="tab-content" id="myTabContent">
                                    <div class="tab-pane fade show active" :id="`activa${cliente.clienteId}`" role="tabpanel" :aria-labelledby="`activa${cliente.clienteId}-tab`">

                                        <div v-if="cliente.cuentasBuroActivas.cuentas.length > 0" class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <grafica-mops :tipoCuentas="'cuentas activas'" :cuentas="cliente.cuentasBuroActivas.cuentas" :mopsMaximos="cliente.cuentasBuroActivas.mopMaximo" :mopsActuales="cliente.cuentasBuroActivas.mopActual"></grafica-mops>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="tab-pane fade" :id="`cerrada${cliente.clienteId}`" role="tabpanel" :aria-labelledby="`#cerrada${cliente.clienteId}-tab`">
                                        <div vif v-if="cliente.cuentasBuroCerradas.cuentas.length > 0" class="row">
                                            <div class="col-md-12 col-lg-12">
                                                <grafica-mops :tipoCuentas="'cuentas cerradas'" :cuentas="cliente.cuentasBuroCerradas.cuentas" :mopsMaximos="cliente.cuentasBuroCerradas.mopMaximo" :mopsActuales="cliente.cuentasBuroCerradas.mopActual"></grafica-mops>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--Fin CCD-0003-->
                    </div>

                    <!-- Si hay obligados solidarios renderizamos -->
                    <div v-for="obligado in operacion.obligadosSolidarios" :key="obligado.personaFisicaId">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <div class="card card-body text-start mb-3 cuerpoDetalle">
                                    <h5 class="card-title">
                                        {{ obligado.figura }}: {{ obligado.nombre }}
                                    </h5>                                    
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-6">
                                <div class="card card-body text-start mb-3 cuerpoDetalleI">
                                    <h5 class="card-title">
                                        Datos buró de crédito
                                    </h5>
                                    <hr />
                                    <div class="texto mb-3">
                                        Pago mensual:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(
                                                    obligado.consultaBuroCredito.pagoMensual
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="texto mb-3">
                                        Deuda actual:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(
                                                    obligado.consultaBuroCredito.deudaActual
                                                )
                                            }}
                                        </div>
                                    </div>
                                    <div class="texto mb-3">
                                        Saldo vencido:
                                        <div class="float-end me-3">
                                             {{
                                                $filters.MoneyFilter(
                                                    obligado.consultaBuroCredito.saldoVencido
                                                )
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-6">
                                <div class="card card-body text-start mb-3 cuerpoDetalleD">
                                    <h5 class="card-title">
                                        Comprobación y capacidades
                                    </h5>
                                    <hr>
                                    <div class="texto mb-3">
                                        Ingresos:
                                        <div class="float-end me-3">
                                            {{
                                                $filters.MoneyFilter(calcularIngresosTotales(obligado.ingresos))
                                            }}
                                            <div class="col-md-4">
                                                <button
                                                    type="button"
                                                    class="btn btn-primary rounded-pill mt-3"
                                                    data-bs-toggle="modal"
                                                    :data-bs-target="`#modalPersona${obligado.personaFisicaId}`"
                                                >
                                                    Detalle
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="texto mb-3">
                                        Egresos:
                                        <div class="float-end me-3">
                                            {{ $filters.MoneyFilter(obligado.egresos) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <modal-detalle-ingresos :persona="obligado"></modal-detalle-ingresos>
                        <!--Inicio CCD-0003 Separación de gráfico de mops en cuentas activas y cerradas-->
                        <div v-if="obligado.cuentasBuroActivas.cuentas.length > 0" class="row">
                            <div class="col-md-12 col-lg-12">
                                <grafica-mops :tipoCuentas="'cuentas activas'" :cuentas="obligado.cuentasBuroActivas.cuentas" :mopsMaximos="obligado.cuentasBuroActivas.mopMaximo" :mopsActuales="obligado.cuentasBuroActivas.mopActual"></grafica-mops>
                            </div>
                        </div>
                        <div vif v-if="obligado.cuentasBuroCerradas.cuentas.length > 0" class="row">
                            <div class="col-md-12 col-lg-12">
                                <grafica-mops :tipoCuentas="'cuentas cerradas'" :cuentas="obligado.cuentasBuroCerradas.cuentas" :mopsMaximos="obligado.cuentasBuroCerradas.mopMaximo" :mopsActuales="obligado.cuentasBuroCerradas.mopActual"></grafica-mops>
                            </div>
                        </div>
                        <!--Fin CCD-0003-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import GraficaMops from '@/Aplicaciones/CCD/Areas/CCD/Componentes/GraficaMops.vue'
import ModalDetalleIngresos from '@/Aplicaciones/CCD/Areas/CCD/Componentes/ModalDetalleIngresos.vue'

export default defineComponent({
    name: 'DetalleTableroControl',

    props: {
        operacion: {}
    },

    components: {
        ModalDetalleIngresos,
        GraficaMops
    },

    methods: {
        calcularIngresosTotales(ingresos){
            let total = ingresos.reduce(function(accumulator, currentValue) {
            return accumulator + currentValue.montoIngreso;
            }, 0);
            return total;
        }
    },
})
</script>

<style scoped>
.nav-tabs .nav-link {
     color: #4d4f5c;
     font-family: Montserrat;
    font-style: normal;
    font-size: 18px;
    line-height: 22px;
}
    .nav-tabs .nav-link.active{
        color: #4d4f5c;
    }
    .nav-tabs .nav-link:hover{
        color: rgba(77, 79, 92, .90);
    }
    .texto,
    p,
    span {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 17px;
        line-height: 21px;
        color: #302d74;
    }

    .btn {
        z-index: 10;
        font-weight: 600;
        font-size: 18px;
    }
</style>